import React from 'react';
import { observer } from 'mobx-react';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Button } from '@this/shared/ui/inputs/button';
import { Input } from '@this/shared/ui/inputs/input';
import { FormControl, InputLabel } from '@this/shared/ui/inputs/form_control';
import type DomesticAirline from '@this/domain/god/domestic_airline';

function getStyles() {
  return {
    buttonRow: {
      display: 'flex',
      gap: '10px',
      marginTop: '20px'
    } as React.CSSProperties,
    error: {
      color: '#dc3545',
      fontSize: '14px',
      marginTop: '10px'
    } as React.CSSProperties,
    note: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      color: '#856404',
      backgroundColor: '#fff3cd',
      border: '1px solid #ffc107',
      borderRadius: '4px',
      fontSize: '13px',
      marginTop: '10px',
      padding: '8px 12px'
    } as React.CSSProperties
  } as const;
}

interface DomesticAirlineFormProps {
  domesticAirline: DomesticAirline;
  onSubmit: () => void;
  onCancel: () => void;
  error: string | null;
  submitLabel: string;
  cancelLabel: string;
  note?: string;
}

const DomesticAirlineForm: React.FC<DomesticAirlineFormProps> = ({
  domesticAirline,
  onSubmit,
  onCancel,
  error,
  submitLabel,
  cancelLabel,
  note
}) => {
  const styles = getStyles();

  return (
    <div>
      <FormControl fullWidth style={{ marginBottom: '10px' }}>
        <InputLabel htmlFor="threeLetterCode">3レターコード *</InputLabel>
        <Input
          id="threeLetterCode"
          value={domesticAirline.threeLetterCode || ''}
          inputProps={{ maxLength: 3 }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            domesticAirline.threeLetterCode = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
          }}
        />
      </FormControl>
      <FormControl fullWidth style={{ marginBottom: '10px' }}>
        <InputLabel htmlFor="twoLetterCode">2レターコード</InputLabel>
        <Input
          id="twoLetterCode"
          value={domesticAirline.twoLetterCode || ''}
          inputProps={{ maxLength: 2 }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
            domesticAirline.twoLetterCode = value || null;
          }}
        />
      </FormControl>
      <FormControl fullWidth style={{ marginBottom: '10px' }}>
        <InputLabel htmlFor="name">航空会社名 *</InputLabel>
        <Input
          id="name"
          value={domesticAirline.name || ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            domesticAirline.name = e.target.value;
          }}
        />
      </FormControl>
      {note && (
        <div style={styles.note}>
          <ErrorOutlineIcon style={{ fontSize: '16px', color: '#856404' }} />
          {note}
        </div>
      )}
      {error && <div style={{ ...styles.error, whiteSpace: 'pre-wrap' }}>{error}</div>}
      <div style={styles.buttonRow}>
        <Button onClick={onSubmit}>{submitLabel}</Button>
        <Button color="sub" onClick={onCancel}>
          {cancelLabel}
        </Button>
      </div>
    </div>
  );
};

export default observer(DomesticAirlineForm);
